module.exports = __webpack_public_path__ + "img/Gilbert.cf0881fc.jpg";